<template>
  <div class="wrapper">
    <div class="main visual-2 queue-counter-main">
      <Header :backRoute="'/appointments'" />
      <div class="queue-content">
        <div class="queue-table-container">
          <div class="queue-filter">
            <input
              type="checkbox"
              class="custom-checkbox"
              v-model="isChecked"
              @change="toggleStorage"
            />Auto
            <i class="fa-solid fa-calendar-days"></i>
            <select class="queue-filter-select" v-model="status">
              <option value="">Select</option>
              <option value="open">Open</option>
              <option value="approved">Approved</option>
              <option value="started">Started</option>
              <option value="waiting">Waiting</option>
              <option value="cancelled">Cancelled</option>
              <option value="completed">Completed</option>
              <option value="inprogress">In Progress</option>
            </select>
          </div>
          <div v-if="error" class="error-message">{{ error }}</div>
          <div class="queue-table-wrapper" v-else>
            <table class="queue-table">
              <thead>
                <tr>
                  <th>Patient Name</th>
                  <th>Doctor Name</th>
                  <th>Q-ID</th>
                  <th>Date</th>
                  <th>EstimatedTime</th>
                  <th>Time</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="appointment in appointments"
                  :key="appointment.id"
                  :style="
                    form.id === appointment.id
                      ? { backgroundColor: 'antiquewhite' }
                      : {}
                  "
                >
                  <td :style="{ cursor: 'pointer' }">
                    <p @click="fillForm(appointment)">
                      {{ $formatName(appointment?.patient) }}
                    </p>
                  </td>
                  <td>
                    {{ $formatName(appointment?.doctor) }}
                  </td>
                  <td>{{ appointment?.qid }}</td>
                  <td>{{ formatDate(appointment?.startTime) }}</td>
                  <td>
                    {{
                      appointment.status === "waiting"
                        ? appointment.humanReadableEstimatedTime
                        : "-"
                    }}
                  </td>
                  <td>
                    {{ formatTime(appointment?.slots?.startTime) }} -
                    {{ formatTime(appointment?.slots?.endTime) }}
                  </td>
                  <td>
                    <span :class="statusClass(appointment?.status)">{{
                      appointment?.status
                    }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="queue-form">
          <form @submit.prevent="updatePatient">
            <div class="form-group">
              <label for="name">Patient Name:</label>
              <input
                type="text"
                id="name"
                v-model="form.name"
                :disabled="true"
              />
            </div>
            <div class="form-group">
              <label for="status">Status:</label>
              <select id="status" v-model="form.status" :disabled="isUpdating">
                <option value="open">Open</option>
                <option value="approved">Approved</option>
                <option value="started">Started</option>
                <option value="waiting">Waiting</option>
                <option value="cancelled">Cancelled</option>
                <option value="completed">Completed</option>
                <option value="inprogress">In Progress</option>
              </select>
            </div>
            <div class="form-group">
              <label for="qId">Q-ID:</label>
              <input type="text" id="qId" v-model="form.qid" :disabled="true" />
            </div>
            <div class="form-group">
              <label for="time">Time:</label>
              <input
                type="text"
                id="time"
                v-model="form.time"
                :disabled="true"
              />
            </div>
            <button type="submit" class="save-btn" :disabled="isUpdating">
              Change and Save

              <span
                v-if="isUpdating"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            </button>
          </form>
        </div>
      </div>
      <FooterView />
    </div>
  </div>
</template>
<script>
import { PatientTimeSlotsService } from "@/services/patient-time-slots.service";
import FooterView from "@/layout/Footer.vue";
import Header from "@/layout/Header.vue";
export default {
  components: {
    FooterView,
    Header,
  },
  name: "QueueCounter",
  data() {
    return {
      appointments: [], // Store appointments data
      error: "", // To store any error messages
      isLoading: true, // Show loading state while fetching data
      isUpdating: false, // Show loader during update
      form: {
        // Data for the form
        id: null,
        name: "",
        qid: "",
        time: "",
        status: "Pending",
      },
      refreshInterval: null, // Store the interval ID for clearing it later
      status: "",
      isChecked: false, // Default state
      storageKey: "autoQueueMainage",
    };
  },
  watch: {
    status() {
      this.fetchAppointments(); // Fetch new data when status changes
    },
  },
  methods: {
    toggleStorage() {
      if (this.isChecked) {
        localStorage.removeItem(this.storageKey);
      } else {
        localStorage.setItem(this.storageKey, "false");
      }
    },
    checkStorage() {
      const storageValue = localStorage.getItem(this.storageKey);
      this.isChecked = !storageValue; // If key exists, uncheck; else, check
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    },
    formatTime(isoString) {
      if (!isoString) return "";
      return new Date(isoString).toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },
    statusClass(status) {
      switch (status) {
        case "open":
          return "status-open";

        case "waiting":
          return "status-waiting";
        case "cancelled":
          return "status-cancelled";
        case "closed":
          return "status-closed";
        case "approved":
          return "status-approved";
        case "started":
          return "status-started";
        case "inprogress":
          return "status-inprogress";
        case "completed":
          return "status-completed";
        default:
          return "status-default"; // For unhandled statuses
      }
    },
    async fetchAppointments() {
      this.isLoading = true; // Start the loading spinner
      try {
        const response = await PatientTimeSlotsService.getList(true, {
          status: this.status,
        });
        this.appointments = response.data.content || []; // Store the list of appointments
        this.error = ""; // Clear any previous errors
      } catch (error) {
        console.log("🚀 ~ fetchAppointments ~ error:", error);
        this.error =
          error?.response?.data?.error?.message ||
          "Failed to load appointments"; // Handle any errors
      } finally {
        this.isLoading = false; // Stop the loading spinner
      }
    },

    // Fill the form when a patient is clicked
    fillForm(appointment) {
      console.log("🚀 ~ fillForm ~ appointment:", appointment);
      this.form.id = appointment.id;
      this.form.name = appointment.patient.firstname; // Assuming appointment.patient has name
      this.form.qid = appointment.qid;
      this.form.time = this.form.time =
        this.formatTime(appointment?.slots?.startTime) +
        " - " +
        this.formatTime(appointment?.slots?.endTime);
      this.form.status = appointment.status;
    },

    // Update the patient's details
    async updatePatient() {
      if (!this.form.id) return;
      this.isUpdating = true; // Show the loader
      try {
        const response = await PatientTimeSlotsService.update(this.form.id, {
          status: this.form.status,
        });
        if (response.success) {
          this.form = {
            id: null,
            name: "",
            qid: "",
            time: "",
            status: "pending",
          };
          // Re-fetch appointments after update
          await this.fetchAppointments();
          return;
        } else {
          this.$store.commit("toast/NEW", {
            type: "error",
            message: response.message,
          });
          return;
        }
        // Reset form after successful update
      } catch (error) {
        this.error =
          error?.response?.data?.error?.message || "Failed to update patient";
      } finally {
        this.isUpdating = false; // Hide the loader
      }
    },
  },
  mounted() {
    this.fetchAppointments();
    this.checkStorage();
    this.refreshInterval = setInterval(() => {
      this.fetchAppointments();
    }, 60000); // 1 min refresh interval
  },
  beforeUnmount() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  },
};
</script>
<style>
/* Hide the default checkbox */
.custom-checkbox {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 20px;
  height: 20px;
  border: 2px solid #007bff;
  border-radius: 4px;
  background-color: #fff;
  display: inline-block;
  position: relative;
  cursor: pointer;
}

/* Checked state */
.custom-checkbox:checked {
  background-color: #007bff;
  border-color: #007bff;
}

/* Checkmark */
.custom-checkbox:checked::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 2px;
  width: 8px;
  height: 12px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
</style>
